<template>
  <base-dropdown menuOnRight class="pub-bell">
    <button slot="title-container" type="button" class="btn btn-link pub-trigger" :aria-label="copy.title">
      <i class="ni ni-bell-55"></i>
      <span v-if="unreadCount" class="pub-count">{{ unreadCount }}</span>
    </button>
    <h6 class="dropdown-header">{{ copy.title }}</h6>
    <span v-if="!items.length" class="dropdown-item-text pub-empty">{{ copy.empty }}</span>
    <a v-for="item in items" :key="item.id" href="#" class="dropdown-item pub-item" :class="{ 'pub-unread': !item.read }" @click.prevent="$emit('open', item.id)">
      <span class="pub-item-title">{{ item.title }}</span>
      <small class="pub-item-date">{{ formatDate(item.published_at) }}</small>
    </a>
  </base-dropdown>
</template>

<script>
const COPY = { title: 'Novedades', empty: 'No hay novedades todavía' };
const DATE_LOCALE = 'es-PE';
const DATE_FORMAT = { day: '2-digit', month: 'short', year: 'numeric' };

export default {
  name: 'PortalUpdatesBell',
  data() {
    return { copy: COPY };
  },
  computed: {
    items() {
      return this.$store.state.portalUpdates.items;
    },
    unreadCount() {
      return this.$store.getters['portalUpdates/unreadCount'];
    },
  },
  methods: {
    formatDate(value) {
      return new Date(value).toLocaleDateString(DATE_LOCALE, DATE_FORMAT);
    },
  },
};
</script>

<style scoped>
.pub-trigger { position: relative; color: #676769; font-size: 20px; padding: 4px 8px; }
.pub-count { position: absolute; top: -2px; right: 0; background: #01662E; color: #fff; border-radius: 10px; font-size: 11px; min-width: 18px; padding: 0 5px; text-align: center; }
.pub-item { display: flex; flex-direction: column; white-space: normal; max-width: 320px; }
.pub-unread .pub-item-title { font-weight: 700; }
.pub-item-date { color: #8a8a8a; }
.pub-empty { color: #8a8a8a; padding: 8px 16px; }
</style>
